<template>
  <v-container class="full-height field-editor" style="position: relative">
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      top
      color="#89C6E3"
      rounded
      centered
    >
      {{ snackbarText }}
    </v-snackbar>
    <!-- <transition name="slide-fade">
      <FieldMap v-if="fieldMapSelection" :fieldMapSelection.sync="fieldMapSelection" :fieldData="fieldData" @update-field-data="update" />
    </transition> -->
    <v-row style="position:absolute; width: 95%; height: 90%;" class="custom-scroll-bar field-editor-row">
      <v-col cols="12" sm="3" style="text-align: -webkit-center">
        <v-img max-height="124" max-width="124" :src="require('@/assets/min-field.png')"/>
      </v-col>
      <v-col cols="12" sm="6" class="text-left">
        <span class="text-h5 font-weight-bold">{{$t('FieldEditor.fieldData')}}</span>
        <v-form v-model="isFormValid" class="mt-7" ref="fieldForm">
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                :label="`${$t('FieldEditor.fieldName')} *`"
                :title="`${$t('FieldEditor.fieldName')} *`"
                v-model="fieldData.name"
                outlined
                background-color="#FFF"
                color="#0098E1"
                :rules="[v => !!v || $t('Config.fieldIsRequired')]"
                required
                maxlength="30"
                hide-details="auto"
              />
            </v-col>
          </v-row>
          <v-row no-gutters class="pt-5">
            <v-col cols="12">
              <v-select
                :menu-props="{ bottom: true, offsetY: true }"
                :items="primaryUsers"
                :item-text="e => `${e.name} ${e.lastName}`"
                item-value="id"
                v-model="fieldData.contact"
                :label="`${$t('FieldEditor.fieldContact')} *`"
                :title="`${$t('FieldEditor.fieldContact')} *`"
                outlined
                background-color="#FFF"
                color="#0098E1"
                :rules="[v => !!v || $t('Config.fieldIsRequired')]"
                required
                hide-details="auto"
              >
                <template v-if="comesFromAnotherRoute && comesFromAnotherRouteName === 'NewCampaignInitialData'" v-slot:append-item>
                  <v-list-item @click="addNewUser('contact')">
                    <v-list-item-title class="add-field-btn">
                      + {{ $t('FieldEditor.addNewUser') }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
          </v-row>
          <v-row no-gutters class="pt-5">
            <v-col cols="12">
              <v-select
                :menu-props="{ bottom: true, offsetY: true }"
                :items="secondaryUsers"
                :item-text="e => `${e.name} ${e.lastName}`"
                item-value="id"
                v-model="fieldData.auxContact"
                :label="`${$t('FieldEditor.fieldAuxContact')}`"
                :title="`${$t('FieldEditor.fieldAuxContact')}`"
                outlined
                background-color="#FFF"
                color="#0098E1"
                hide-details="auto"
              >
                <template v-if="comesFromAnotherRoute && comesFromAnotherRouteName === 'NewCampaignInitialData'" v-slot:append-item>
                  <v-list-item @click="addNewUser('auxContact')">
                    <v-list-item-title class="add-field-btn">
                      + {{ $t('FieldEditor.addNewUser') }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-select>
              <p class="aux-contact-subtitle pt-3">{{ $t('FieldEditor.auxContactSubtitle') }}</p>
            </v-col>
          </v-row>
          <!-- <v-row no-gutters class="mt-12">
            <v-col cols="10" offset="1" class="text-center">
              <v-btn
                @click="fieldMapSelection = true"
                block
                color="#0098E1"
                large
                class="text-none text-h6 font-weight-light"
                :dark="true"
              >{{$t('FieldEditor.markGates')}}</v-btn>
            </v-col>
          </v-row> -->
          <span class="text-h6 font-weight-bold">{{$t('FieldEditor.gates')}}</span>
          <v-row no-gutters class="mt-2">
            <v-col cols="10" class="text-center">
              <div v-if="fieldData.gates">
                <v-row v-for="(point, pointIndex) in fieldData.gates" :key="`point_${pointIndex}`" class="align-start">
                  <!-- Desktop: horizontal layout -->
                  <v-col cols="5" class="py-1 d-none d-md-block">
                    <v-text-field
                      :label="`${$t('AddDevice.latitude')} *`"
                      :title="`${$t('AddDevice.latitude')} *`"
                      v-model.number="point.latitude"
                      outlined
                      background-color="#FFF"
                      color="#0098E1"
                      dense
                      :hint="`${$t('FieldEditor.coordinatesHint')}`"
                      flat
                      :rules="[v => (v === '' || v === null || v === undefined) || /^[+|-]?\d+([.]\d+)?$/.test(v) || $t('Config.onlyNumbers'), v => (v === '' || v === null || v === undefined) || (v <= 90 && v >= -90) || $t('Config.latitudeRule')]"
                      hide-details="auto"
                      persistent-hint
                      validate-on-blur
                    />
                  </v-col>
                  <v-col cols="5" class="py-1 d-none d-md-block">
                    <v-text-field
                      :label="`${$t('AddDevice.longitude')} *`"
                      :title="`${$t('AddDevice.longitude')} *`"
                      v-model.number="point.longitude"
                      outlined
                      background-color="#FFF"
                      color="#0098E1"
                      dense
                      :hint="`${$t('FieldEditor.coordinatesHint')}`"
                      flat
                      :rules="[v => (v === '' || v === null || v === undefined) || /^[+|-]?\d+([.]\d+)?$/.test(v) || $t('Config.onlyNumbers'), v => (v === '' || v === null || v === undefined) || (v <= 180 && v >= -180) || $t('Config.longitudeRule')]"
                      hide-details="auto"
                      persistent-hint
                      validate-on-blur
                    />
                  </v-col>
                  <v-col cols="2" class="py-1 d-none d-md-flex justify-center align-center">
                    <v-btn fab x-small elevation="1" color="#FFF" @click="deleteGatePoint(pointIndex)">
                      <v-icon small color="black">remove</v-icon>
                    </v-btn>
                  </v-col>

                   <!-- Mobile: vertical layout -->
                   <v-col cols="12" class="py-1 d-block d-md-none">
                     <v-row class="align-stretch">
                       <v-col cols="10">
                         <v-text-field
                           :label="`${$t('AddDevice.latitude')} *`"
                           :title="`${$t('AddDevice.latitude')} *`"
                           v-model.number="point.latitude"
                           outlined
                           background-color="#FFF"
                           color="#0098E1"
                           dense
                           :hint="`${$t('FieldEditor.coordinatesHint')}`"
                           flat
                           :rules="[v => (v === '' || v === null || v === undefined) || /^[+|-]?\d+([.]\d+)?$/.test(v) || $t('Config.onlyNumbers'), v => (v === '' || v === null || v === undefined) || (v <= 90 && v >= -90) || $t('Config.latitudeRule')]"
                           hide-details="auto"
                           validate-on-blur
                         />
                         <v-text-field
                           :label="`${$t('AddDevice.longitude')} *`"
                           :title="`${$t('AddDevice.longitude')} *`"
                           v-model.number="point.longitude"
                           outlined
                           background-color="#FFF"
                           color="#0098E1"
                           dense
                           :hint="`${$t('FieldEditor.coordinatesHint')}`"
                           flat
                            :rules="[v => (v === '' || v === null || v === undefined) || /^[+|-]?\d+([.]\d+)?$/.test(v) || $t('Config.onlyNumbers'), v => (v === '' || v === null || v === undefined) || (v <= 180 && v >= -180) || $t('Config.longitudeRule')]"
                           hide-details="auto"
                           validate-on-blur
                           class="mt-2"
                         />
                       </v-col>
                       <v-col cols="2" class="d-flex justify-center mt-5">
                         <v-btn fab x-small elevation="1" color="#FFF" @click="deleteGatePoint(pointIndex)">
                           <v-icon small color="black">remove</v-icon>
                         </v-btn>
                       </v-col>
                     </v-row>
                   </v-col>
                </v-row>
                <v-row align="center" class="justify-start" style="margin-top:0">
                  <v-btn fab x-small elevation="1" color="#FFF" @click="addGatePoint">
                    <v-icon color="#0098E1">add</v-icon>
                  </v-btn>
                  <span class="ml-2">{{$t('AddDevice.addPoint')}}</span>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="12" style="align-self: end">
        <v-row>
          <v-col cols="10" offset="1" sm="4" offset-sm="4" class="d-flex flex-column align-center">
            <v-btn
              @click="saveHandler"
              block
              color="#0098E1"
              large
              class="text-none text-h6 font-weight-light"
              :disabled="!(isFormValid && fieldData.gates.length)"
              :dark="!!(isFormValid && fieldData.gates.length)"
              :loading="loading"
            >{{$t('FieldEditor.register')}}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import FieldMap from './FieldMap'
import { upsertField } from '../../../lib/crudOperations/write'
import { trackEvent } from '../../../lib/track-events'
import { EVENTS_TO_TRACK } from '../../../constants/const'

export default {
  // components: {
  //   FieldMap
  // },
  data () {
    return {
      isFormValid: true,
      // fieldMapSelection: false,
      snackbar: false,
      snackbarTimeout: 3000,
      snackbarText: '',
      loading: false,
      textCoordsFlag: undefined
    }
  },
  props: {
    fieldData: {
      type: Object,
      required: true
    },
    comesFromAnotherRoute: {
      type: Boolean,
      required: true
    },
    comesFromAnotherRouteData: {
      type: Object,
      required: true
    },
    isNewField: {
      type: Boolean,
      required: true
    },
    comesFromAnotherRouteName: {
      type: String,
      required: false
    }
  },
  methods: {
    async saveHandler () {
      if (this.$refs.fieldForm.validate()) {
        this.loading = true
        try {
          if (this.comesFromAnotherRoute) {
            const newFieldId = await upsertField(this.fieldData, this.isNewField, this.comesFromAnotherRouteData.campaignId)
            this.$root.snack.show({text: this.$t('UI.registerSuccess')})
            this.$router.push({
              name: this.comesFromAnotherRouteName,
              params: {
                comesFromAnotherRoute: true,
                comesFromAnotherRouteData: {
                  ...this.comesFromAnotherRouteData,
                  newFieldId
                }
              }
            })
          } else {
            await upsertField(this.fieldData, this.isNewField, null)
            this.$root.snack.show({text: this.$t('UI.registerSuccess')})
            this.$router.push({name: 'OrganizationHome'})
          }
        } catch (err) {
          this.$root.snack.show({text: this.$t('UI.registerError'), error: true})
        } finally {
          this.loading = false
        }
      }
    },
    // openMap () {
    //   if (!!this.cropData[this.cropSelected].field && !!this.cropData[this.cropSelected].name && !!this.cropData[this.cropSelected].device) {
    //     this.cropMapSelection = true
    //   } else {
    //     this.snackbar = true
    //     if (!this.cropData[this.cropSelected].device) {
    //       this.snackbarText = this.$t('AddCrop.deviceRequired')
    //     } else if (!this.cropData[this.cropSelected].name) {
    //       this.snackbarText = this.$t('AddCrop.nameRequired')
    //     } else if (!this.cropData[this.cropSelected].field) {
    //       this.snackbarText = this.$t('AddCrop.fieldRequired')
    //     }
    //   }
    // },
    update (fieldData) {
      this.$emit('update:fieldData', fieldData)
    },
    addGatePoint () {
      this.fieldData.gates = [...this.fieldData.gates, {}]
    },
    deleteGatePoint (index) {
      this.fieldData.gates = this.fieldData.gates.filter((p, i) => i !== index)
    },
    addNewUser (contactPropertyName) {
      if (this.comesFromAnotherRoute && this.comesFromAnotherRouteName === 'NewCampaignInitialData') {
        trackEvent(EVENTS_TO_TRACK.CLICK_ADD_NEW_FIELD_CONTACT_USER_BUTTON, {
          campaignId: this.comesFromAnotherRouteData.campaignId
        })
        this.$router.push({
          name: 'AddUser',
          params: {
            originCampaignId: this.comesFromAnotherRouteData.campaignId,
            fromNewField: true,
            fromNewFieldData: {
              contactPropertyName,
              isNewField: this.isNewField,
              field: this.fieldData,
              comesFromAnotherRoute: this.comesFromAnotherRoute,
              comesFromAnotherRouteData: this.comesFromAnotherRouteData,
              comesFromAnotherRouteName: this.comesFromAnotherRouteName
            }
          }
        })
      }
    }
  },
  computed: {
    userSource () {
      // If the field is being edited from the organization home or edit campaign view, use the campaign users
      if (!this.comesFromAnotherRoute || this.comesFromAnotherRouteName === 'EditCampaignDevicesAndServices') {
        return this.$store.getters.users
      } else {
        // If the field is being edited from the NewCampaignView, we use the organization users
        return this.$store.getters.organizationUsers
      }
    },
    getFilteredUsers () {
      return (excludeUserId) => {
        return this.userSource
          .filter(user => user.id !== excludeUserId)
          .sort((a, b) => a.name.localeCompare(b.name))
      }
    },
    primaryUsers () {
      return this.getFilteredUsers(this.fieldData.auxContact)
    },
    secondaryUsers () {
      return this.getFilteredUsers(this.fieldData.contact)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldEditor.vue?2501c595